import {
  Avatar,
  Badge,
  Button,
  Flex,
  Td,
  Text,
  Tr,
  Icon,
  Link,
  useColorModeValue
} from "@chakra-ui/react";
import React from "react";
import config from "config/index";
import { RiBox1Line } from "react-icons/ri";
import IconBox from "components/Icons/IconBox";
import { useHistory, useLocation } from "react-router-dom";

function TablesTableRow(props) {
  const history = useHistory();
  const { id, logo, name, active, date, menu, chat, radio, isLast, address, number, sort } = props;
  const textColor = useColorModeValue("gray.500", "white");
  const titleColor = useColorModeValue("gray.700", "white");
  const bgStatus = useColorModeValue("gray.400", "navy.900");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  return (
    <Tr>
      <Td
        minWidth={{ sm: "250px" }}
        pl="0px"
        borderColor={borderColor}
        borderBottom={isLast ? "none" : null}
      >
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          <IconBox ml={"20px"} as='box' >
            <Icon h={"25px"} w={"25px"} color={titleColor} as={RiBox1Line} />
          </IconBox>
          <Flex direction="column">
            <Text
              fontSize="sm"
              color={titleColor}
              minWidth="100%">
              {name}
            </Text>
          </Flex>
        </Flex>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Badge
          bg="blue.400"
          color="white"
          fontSize="xs"
          p="3px 10px"
          borderRadius="8px">
          <Link fontSize="xs"
            color='white'
            target="_blank"
            href={config.host + "/tour/" + address + "/" + number}>
            مشاهده
          </Link>
        </Badge>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Badge
          bg={active === true ? "green.400" : bgStatus}
          color={active === true ? "white" : "white"}
          fontSize="xs"
          p="3px 10px"
          borderRadius="8px"
        >
          {active == true ? "فعال" : "غیرفعال"}
        </Badge>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Badge
          bg={menu === true ? "green.400" : bgStatus}
          color={menu === true ? "white" : "white"}
          fontSize="xs"
          p="3px 10px"
          borderRadius="8px"
        >
          {menu == true ? "دارد" : "ندارد"}
        </Badge>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Badge
          bg={chat === true ? "green.400" : bgStatus}
          color={chat === true ? "white" : "white"}
          fontSize="xs"
          p="3px 10px"
          borderRadius="8px"
        >
          {chat == true ? "دارد" : "ندارد"}
        </Badge>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Badge
          bg={radio === true ? "green.400" : bgStatus}
          color={radio === true ? "white" : "white"}
          fontSize="xs"
          p="3px 10px"
          borderRadius="8px"
        >
          {radio == true ? "دارد" : "ندارد"}
        </Badge>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        
        <Text fontSize="xs" color={textColor} dir="ltr" textAlign="right" pb=".5rem">
        {sort}
        </Text>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Text fontSize="xs" color={textColor} dir="ltr" textAlign="right" pb=".5rem">
          {date}
        </Text>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Link onClick={() => history.push("/admin/rooms/" + address + "/details/" + id)} p="0px"  >
          <Text
            fontSize="xs"
            color="gray.400"

            cursor="pointer"
          >
            ویرایش
          </Text>
        </Link>
      </Td>
    </Tr>
  );
}

export default TablesTableRow;
